import { Link, useNavigate } from 'react-router-dom';
import { Badges, Image, P, SVG } from '../../AbstractElements';
import { Href } from '../../utils/Constant';
import { dynamicImage } from '../../Service';
import { TableColumn } from 'react-data-table-component';
import { User } from '.';
import { usersApi } from '../../Api';
import { notification, Popconfirm } from 'antd';
import { toast } from 'react-toastify';

const UserListTableAction = ({ id, user_type_id }: { id: any; user_type_id: any }) => {
    const navigate = useNavigate();
    return (
        <div className="product-action">
            <SVG
                iconId="edit-content"
                onClick={() =>
                    navigate(
                        `${process.env.PUBLIC_URL}/${
                            user_type_id === 2 ? 'suppliers' : 'customers'
                        }/detail/${id}`
                    )
                }
            />

            <Popconfirm
                title="Delete the user"
                description="Are you sure to delete this user?"
                onConfirm={() => {
                    usersApi
                        .delete(id)
                        .then((res) => {
                            toast.success('Delete success');
                            navigate(
                                `${process.env.PUBLIC_URL}/${
                                    user_type_id === 2 ? 'suppliers' : 'customers'
                                }`
                            );
                        })
                        .catch((err) => {
                            toast.warning('Something has occurred !!!');
                            console.error(err);
                        });
                }}
                okText="Yes"
                cancelText="No">
                <div>
                    <SVG iconId="trash1" />
                </div>
            </Popconfirm>
        </div>
    );
};

export const userListTableDataColumn: TableColumn<User>[] = [
    {
        name: 'Full Name',
        cell: (row) => (
            <div className="product-names my-2">
                <div className="light-product-box">
                    <Image
                        style={{ height: '100%' }}
                        className="img-fluid"
                        src={
                            row.profile_picture_url ??
                            'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRNBRW6kw4PvewS5EGHKY7nNsJiWvrbsVIzZA&s'
                        }
                        alt="avatar"
                    />
                </div>
                <P>
                    {row.first_name} {row.last_name}
                </P>
            </div>
        ),
        sortable: true,
        grow: 2
    },
    {
        name: 'Phone',
        selector: (row) => `${row.mobileNo}`,
        sortable: true
    },
    {
        name: 'Email',
        selector: (row) => `${row.email}`,
        sortable: true
    },
    // {
    //     name: 'Gender',
    //     selector: (row) => `${row.gender}`,
    //     sortable: true
    // },
    {
        name: 'Company',
        selector: (row) => `${row.company}`,
        sortable: true
    },
    {
        name: 'Address',
        selector: (row) => `${row.address}`,
        sortable: true
    },
    {
        name: 'City',
        selector: (row) => `${row.city}`,
        sortable: true
    },
    {
        name: 'Action',
        cell: (row) => (
            <UserListTableAction
                id={row.id}
                user_type_id={row.user_type_id}
            />
        )
    }
];
